import React from 'react';
//#region Module
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import ChartIcon from '../../chartIcon'
import { useNavigate, useLocation } from 'react-router-dom';

import moment from 'moment'
// material
import { Card, CardContent, Typography, Box, Grid, CardHeader, IconButton, CardActionArea, Button, Menu, Fade, MenuItem } from '@mui/material'
import CardMedia from '@mui/material/CardMedia'
import SvgIcon from "@mui/material/SvgIcon";
import ViewIcon from "../../../assets/icons/icon-feather-eye.svg"
import DeleteIcon from "../../../assets/icons/icon-delete.svg"
import { ReactComponent as AddIcon } from "../../../assets/icons/icon-add-dashboard.svg"
import MoveIcon from "../../../assets/icons/icon-move.svg"
import RemoveFromFolderIcon from "../../../assets/icons/icon-folder-remove.svg"
import FavouriteIcon from "../../../assets/icons/icon-favorite-border.svg"
import FavouriteFilledIcon from "../../../assets/icons/icon-favorite-filled.svg"
import EditIcon from "../../../assets/icons/icon_edit.svg";
import ExportIcon from "../../../assets/icons/icon-card-export.svg";
import { makeStyles } from '@mui/styles'
import { DecryptData } from "../../../utils/encryptDecrypt";
import { validateUserRole } from '../../../config/services/role';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { ReportCardTitleLength, ReportCardDescriptionLength } from "../../../constants/stringParams";
import { handleStringLength } from "../../../utils/multiLangDashboardV2Data";


//#endregion

const useStyles = makeStyles((theme) => ({
  actionArea: {
    "&:hover $focusHighlight": {
      opacity: 0
    }
  },
  focusHighlight: {},
  btnIcon: {
    boxShadow: 'none',
    backgroundColor: 'transparent',
    borderRadius: 0,
    "&:focus, &.Mui-focusVisible, &:active": {
      boxShadow: 'none',
      backgroundColor: 'transparent',
      borderRadius: 0,
    },
  }
}));


export default function ReportCard({ report, handleDeleteReport,handleChangeOwnerPopup, handleFavrtReport, handleMoveReportPopup, handleEditReport, handleRemoveReportFrmFolder, handleViewReport, pageNo }) {
  const { isFavourite, reportName, description, folderId } = report
  const navigate = useNavigate()
  const classes = useStyles();
  const search = useLocation().search
  let folderName = new URLSearchParams(search).get('folderName');
  let role = DecryptData(localStorage.getItem('role'))
  let currentUser = DecryptData(localStorage.getItem('s_uuid'))
  const [currentUserType, setCurrentUserType] = React.useState({})
  const [cardExportMenuEl, setCardExportMenuEl] = React.useState(null);
  const [exportCsv,setExportCsv] = React.useState(false)
  const openCardExportMenu = Boolean(cardExportMenuEl);

  React.useEffect(() => {
    validateUserRole().then(res => {
      if (res && res?.userType && res?.userType?.length) {
        setCurrentUserType(res?.userType[0])
      }
    })
  }, [])

  const handleCardExportMenuClick = (event) => {
    if (cardExportMenuEl !== event.currentTarget) {
      setCardExportMenuEl(event.currentTarget);
    }
  };

  const handleReportExport = (type,id) => {
    window.open(`/reportGraph/${id}?export=true&type=${type}`);
  }

  return (
    <>
    <Card className="report-card">
      <CardHeader
        className="report-card-header"
        action={
          <IconButton title="Add To Favorites" className='report-favorite-icon' onClick={() => handleFavrtReport(report)} >
            {isFavourite ? <span><img src={FavouriteFilledIcon} /></span> : <span><img src={FavouriteIcon} /></span>}
          </IconButton>
        }
        title={<Button variant="text" className="blk_icon card-main-title" onClick={() =>handleEditReport('/reportGraph/' + report._id + '?pageNo=' + pageNo + (folderId ? '&folderId=' + folderId + '&folderName=' + folderName : '')) }
        >
          <h3 title={reportName}> {handleStringLength(reportName, ReportCardTitleLength)} </h3>
        </Button>}
        subheader={
          <>
            <p className='card-desc' title={description}>{handleStringLength(description, ReportCardDescriptionLength) || 'No Description'} </p>
            {(role?.toLowerCase()) === 'superadmin' ?<p className='card-meta'>Created By: {report?.createdBy}</p> : null}
            <p className='card_sub_content'>Edited: {moment(report.updatedAt).fromNow()}</p>
          </>
        }
      />
      <CardActionArea className="report-card-action" onClick={() =>handleEditReport('/reportGraph/' + report._id + '?pageNo=' + pageNo + (folderId ? '&folderId=' + folderId + '&folderName=' + folderName : ''))}
        //component={Link} to={'/reportGraph/' + report._id}
        classes={{
          root: classes.actionArea,
          focusHighlight: classes.focusHighlight
        }}>
        <CardContent className="report-card-content brdr_btm">
          <CardMedia
            component="img"
            className="report-card-media"
            src={ChartIcon({ chartType: report.chartType })}
            title={report.reportName}
          />
        </CardContent>
      </CardActionArea>

      <CardContent className='report-card-footer'>
        <Grid container direction="row" alignItems="center" wrap="wrap">

              <Grid item className="report-card-footer-item">
                <Box display='flex' alignItems='center' my={1}>
                  <IconButton disableRipple={true} onClick={() => handleEditReport('/reportGraph/' + report._id + '?pageNo=' + pageNo + (folderId ? '&folderId=' + folderId + '&folderName=' + folderName : '')) }
                    className={classes.btnIcon + " report-card-footer-icon report-card-btn-icon no-hover"} >
                    <img color="primary" src={EditIcon} alt="Edit" title="Edit" />
                    <Typography className='report-card-footer-item-txt' ml={1}> Edit</Typography>
                  </IconButton>
                </Box>
              </Grid>
            

          <Grid item className="report-card-footer-item">
            <Box display='flex' alignItems='center' my={1}>
              <IconButton disableRipple={true} onClick={() => handleViewReport('/report-view/' + report._id)}
                className={classes.btnIcon + " report-card-footer-icon report-card-btn-icon no-hover"} >
                <img color="primary" src={ViewIcon} alt="View" title="View" />
                <Typography className='report-card-footer-item-txt' ml={1}> View</Typography>
              </IconButton>
            </Box>

          </Grid>
          {
            (role === 'superadmin' || report.createdBy == currentUser ) && (
              <Grid item className="report-card-footer-item">
                <Box display='flex' alignItems='center' my={1} >
                  <IconButton disableRipple={true} onClick={() => handleDeleteReport(report)} className={classes.btnIcon + " report-card-footer-icon report-card-btn-icon no-hover"} >
                    <img src={DeleteIcon} color="primary" title="Delete" />
                    <Typography className='report-card-footer-item-txt' ml={1}> Delete</Typography>
                  </IconButton>
                </Box>
              </Grid>
            )
          }
          
          {/* <Grid item className="report-card-footer-item" >
            <Box display='flex' alignItems='center' my={1}  >
            <Link onClick={""} className="report-card-footer-icon" to={"/reportGraph/" + report._id}>
              <SvgIcon component={AddIcon} color="primary" />
              <Typography className='report-card-footer-item-txt' ml={1}> Add Dashboard</Typography>
              </Link>
            </Box>
          </Grid> */}
          <Grid item className="report-card-footer-item" >
            <Box display='flex' alignItems='center' my={1}>
              <IconButton disableRipple={true} className={classes.btnIcon + ' report-card-footer-icon report-card-btn-icon no-hover'} onClick={() => handleMoveReportPopup('Open', report)} >
                <img src={MoveIcon} color="primary" title="Move" />
                <Typography className='report-card-footer-item-txt' ml={1}> Move</Typography>
              </IconButton>
            </Box>
          </Grid>
          {
            (role === 'superadmin') && (
              <Grid item className="report-card-footer-item" >
                <Box display='flex' alignItems='center' my={1}>
                  <IconButton disableRipple={true} className={classes.btnIcon + ' report-card-footer-icon report-card-btn-icon no-hover'} onClick={() => handleChangeOwnerPopup('Open', report)} >
                    <PersonOutlineIcon color="primary" title="Change Owner"/>
                    <Typography className='report-card-footer-item-txt' ml={1}> Change Owner</Typography>
                  </IconButton>
                </Box>
              </Grid>
            )
          }

          <Grid item className="report-card-footer-item" >
            <Box display='flex' alignItems='center' my={1}>
              <IconButton disableRipple={true} className={classes.btnIcon + ' report-card-footer-icon report-card-btn-icon no-hover'} onClick={(e) => handleCardExportMenuClick(e)} >
                <img className='report-export' src={ExportIcon} color="primary" title="Export" />
                <Typography className='report-card-footer-item-txt'  ml={1}> Export</Typography>
              </IconButton>
              <Menu
                id="card-export-menu"
                MenuListProps={{
                  'aria-labelledby': 'card-export-button',
                  //'onMouseLeave': () => setMoreExportMenuEl(null)
                }}
                classes={{
                  root: 'popover-exportmenu-report-header popover-menu'
                }}
                PaperProps={{
                  style: {
                    minWidth: 110,
                  },
                }}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                anchorEl={cardExportMenuEl}
                open={openCardExportMenu}
                onClose={() => setCardExportMenuEl(null)}
                TransitionComponent={Fade}
              >
                { (role?.toLowerCase() === 'superadmin' || (  
                currentUserType && currentUserType?.exportAuth?.pdf) )&&
                <MenuItem className={classes.menuDropdownItem + " menu-item"} 
                onClick={e => handleReportExport('pdf',report._id)}
                >PDF</MenuItem>
              }
              {(role?.toLowerCase() === 'superadmin' || (  
                currentUserType && currentUserType?.exportAuth?.csv) )&&
                <MenuItem className={classes.menuDropdownItem + " menu-item"} 
                onClick={e => handleReportExport('csv',report._id)}
                >CSV file</MenuItem>
              }
              { (role?.toLowerCase() === 'superadmin' || (  
                currentUserType && currentUserType?.exportAuth?.excel)) &&
                <MenuItem className={classes.menuDropdownItem + " menu-item"} 
                onClick={e => handleReportExport('excel',report._id)}
                >Excel file</MenuItem>
              }
              </Menu>

            </Box>
          </Grid>

          {folderId ? <Grid item className="report-card-footer-item" >
            <Box display='flex' alignItems='center' my={1}>
              <IconButton disableRipple={true} className={classes.btnIcon + ' report-card-footer-icon report-card-btn-icon no-hover'} onClick={() => handleRemoveReportFrmFolder('Open', report)} >
                <img src={RemoveFromFolderIcon} color="primary" title="Remove From Folder" />
                <Typography className='report-card-footer-item-txt' ml={1}>Remove From Folder</Typography>
              </IconButton>
            </Box>
          </Grid> : null}

        </Grid>
      </CardContent>
    </Card>

   
    </>
  )
}

ReportCard.propTypes = {
  report: PropTypes.object,
}
